module.exports = __webpack_public_path__ + "static/media/folder.dda39cfb.svg";